(() => {
  const section = document.querySelector('.bsb-vb');
  if (!section) return;

  const video    = section.querySelector('.bsb-vb__video');
  const pauseBtn = section.querySelector('.bsb-vb__pause');

  // Pause autoplay if user prefers reduced motion
  if (video && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    video.pause();
    video.removeAttribute('autoplay');
  }

  // Pause / play toggle
  if (video && pauseBtn) {
    const iconPlay  = pauseBtn.querySelector('.bsb-vb__pause-icon--play');
    const iconPause = pauseBtn.querySelector('.bsb-vb__pause-icon--pause');

    const syncState = () => {
      const paused = video.paused;
      pauseBtn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      pauseBtn.setAttribute('aria-pressed', String(paused));
      paused ? iconPlay.removeAttribute('hidden') : iconPlay.setAttribute('hidden', '');
      paused ? iconPause.setAttribute('hidden', '') : iconPause.removeAttribute('hidden');
    };

    pauseBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      video.paused ? video.play() : video.pause();
      syncState();
    });

    video.addEventListener('play',  syncState);
    video.addEventListener('pause', syncState);
    syncState();
  }

  // Stop the pill CTA click from also triggering the banner overlay link
  const cta = section.querySelector('.bsb-vb__cta');
  if (cta) {
    cta.addEventListener('click', (e) => e.stopPropagation());
  }
})();
